import { render, staticRenderFns } from "./PartnerGradeApprovalAll.vue?vue&type=template&id=d9c47cb6&scoped=true"
import script from "./PartnerGradeApprovalAll.vue?vue&type=script&lang=js"
export * from "./PartnerGradeApprovalAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c47cb6",
  null
  
)

export default component.exports